export const maxEuroDecimals = 2;
// TODO: What should the highest number be for e.g. EUR?
export const maxAssetInputLength = 10;
export const maxWithdrawalAmountLength = 30;
export const emailRegexp =
  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9][a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

export const phoneRegexp = /^\+[0-9]?()[0-9](\s|\S)(\d[0-9]{5,15})$/gm;

export const DEFAULT_MARKET = 'btc-eur';

export const CONFIRM_AMOUNT_THRESHOLD = 100000;
